import { render, staticRenderFns } from "./DialogForgetPassword.vue?vue&type=template&id=8fc6d028&scoped=true"
import script from "./DialogForgetPassword.vue?vue&type=script&lang=js"
export * from "./DialogForgetPassword.vue?vue&type=script&lang=js"
import style0 from "./DialogForgetPassword.vue?vue&type=style&index=0&id=8fc6d028&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc6d028",
  null
  
)

export default component.exports